import {
  Component,
  ElementRef,
  EventEmitter,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Questionnaire} from '../../model/questionnaire';
import {Project} from '../../model/project';
import {ProjectService} from '../project.service';
import {Constants} from '../../model/constants';
import {FileToDownload} from '../../model/file-to-download';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Terminal} from '../../model/terminal';
import {Email} from '../../model/email/email';
import {CreateEmailComponent} from '../email/create-email.component';
import {Sms} from '../../model/sms/sms';
import {PostSynchroActions} from '../../model/PostSynchro/postSynchroActions';
import {TerminalUtil} from '../../util/terminalUtil';
import {FileChooserComponent} from '../../FileChooser/file-chooser.component';
import {ImportDuplicateModalComponent} from '../../import-duplicate-modal/import-duplicate-modal.component';
import {CurrentContext} from '../../model/currentContext';
import {SocialMediaContentDefinitionComponent} from '../../socialMediaContentDefinition/social-media-content-definition.component';
import {Database} from '../../model/database/database';
import {SharedRefreshService} from '../../service/sharedRefreshService';
import {CreateSmsComponent} from '../sms/create-sms.component';
import {GenericModalComponent} from '../../modal/generic-modal.component';
import {ContentPreviewComponent} from '../emailPreview/content-preview.component';
import {ContentPreview} from '../../model/contentPreview';
import {CloningStructure} from '../../model/cloning/cloningStructure';
import {CloneReferencedProject} from '../../model/cloning/cloneReferencedProject';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {Device} from '../../model/device';
import {MapUtil} from '../../util/mapUtil';
import {Clone} from '../../model/cloning/clone';
import {EmailComposerComponent} from '../emailComposer/email-composer.component';

@Component({
    selector : 'questionnaire-node',
    template: `
      <div class="col card" style="padding: 10px;">
        <div class="w3-card-4">
          <header class="w3-container header-container">
            <h4 class="headerTitle">
                <span>
                    <img alt="icon" *ngIf="this.terminal.type=='Windows' && !this.isWebTerminal()" style="height:40px;margin-right:5px;" src="../../../assets/images/windows%20logo2.png">
                    <img alt="icon" *ngIf="this.terminal.type=='Android'  && !this.isWebTerminal()" style="height:40px;margin-right:5px;" src="../../../assets/images/androidLogo.png">
                    <img alt="icon" *ngIf="this.isWebTerminal()" style="height:40px;margin-right:5px;" src="../../../assets/images/292.png">
                </span>{{terminal.name}}
            </h4>
            <div class="w3-padding w3-xlarge w3-text-white">
              <div style="float:right;">
                <button type="button" class="btn btn-primary btn-lg" (click)="onImport($event)" value="project" data-toggle="tooltip"
                        data-placement="bottom" title="Import Files" style="margin-right:3px"><img alt="icon" class="titleBarIcon" src="../../../assets/images/001.png">
                </button>
              </div>
              <div>
                <button type="button" class="btn btn-danger btn-lg" (click)="removeTerminal(terminal.id)" data-toggle="tooltip"
                        data-placement="bottom" title="Delete Terminal"><img alt="icon" class="titleBarIcon" src="../../../assets/images/trash.png">
                </button>
              </div>
            </div>
          </header>
          <div class="w3-container">
            <breadcrumb [path]="generateBreadCrumb()" (breadCrumbLink)="onBreadCrumbLink($event)"></breadcrumb>
            <div class="card-body">
              <span *ngIf="!this.isWebTerminal()"><img class="terminalIcon" src="../../../assets/images/windowsTablet.png" alt="Terminal"></span>
              <span *ngIf="this.isWebTerminal()"><img class="terminalIcon" src="../../../assets/images/webApp.png" alt="Terminal"></span>

              <div class="card cardForm">
                <h5 class="card-header"><span><img class="titleBar" src="../../../assets/images/251.png" alt="icon"></span>Properties</h5>
                <div class="card-body">

                    <div class="row">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ID</span>
                            </div>
                            <input type="text" class="form-control" aria-describedby="basic-addon3" [value]=this.terminal.id readonly>
                        </div>
                    </div>

                  <div class="row">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">Selected Terminal</span>
                      </div>
                      <input type="text" class="form-control" aria-describedby="basic-addon3" [value]=this.terminal.name readonly>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">Root Project Name</span>
                      </div>
                      <input type="text" class="form-control" aria-describedby="basic-addon3" [value]=this.project.name readonly>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon4">{{'Created Date'|translate}}</span>
                      </div>
                      <input type="text" class="form-control" aria-describedby="basic-addon3" [(ngModel)]="terminal.createdDate" readonly>
                    </div>

                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon5">{{'Last Modified Date'|translate}}</span>
                      </div>
                      <input type="text" class="form-control" aria-describedby="basic-addon3" [(ngModel)]="terminal.lastModifiedDate" readonly>
                    </div>
                  </div>
                </div>
              </div>
                <!-- database deffinition component should go here -->
                <database-creator *ngIf="this.isWebTerminal()" [database]="this.database"></database-creator>

              <div *ngIf="active" class="panel panel-default" style="margin-top: 50px;">
                <form (ngSubmit)="validate(questionnaireForm.form) && onUpdate()" #questionnaireForm="ngForm">
                    <div class="card cardForm">
                        <div class="card-header">
                            <h5><span><img alt="icon" class="titleBar" src="../../../assets/images/systemProperties.png"></span>Terminal Information</h5>
                        </div>
                        <div class="card col-md-12">
                            <div class="card-body">
                              <div class="row top-buffer">

                                <div class="col-md-3">
                                  <label>Client Type: </label>

                                </div>
                                <ng-container *ngIf="!this.isWebTerminal()">
                                    <div *ngIf="this.definedClient != 0" class="col-md-3" style="width: 300px;margin-bottom: 20px;">
                                      <input type="text" class="form-control" [value]=this.clientType[definedClient] readonly/>
                                    </div>
                                    <div *ngIf="this.definedClient == 0" class="col-md-3" style="width: 300px;margin-bottom: 20px;">
                                      <!--<select class="form-control" style="width: 180px;display:inline;" [attr.disabled]="this.terminal.type ? true:null" (change)="onOptionSelected($event.target.value)">
                                          <option *ngFor="let type of this.clientType" [value]="type"   [attr.selected]="(type == this.clientType[definedClient]) ? '': null" >{{ type }}</option>
                                      </select>-->

                                      <ngx-select [allowClear]="false"
                                                  [placeholder]=this.clientType[definedClient]
                                                  [items]="this.clientType"
                                                  (select)="selected($event)"
                                                  (data)="refreshValue($event)"
                                      ></ngx-select>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.isWebTerminal()">
                                  <div class="col-md-3" style="width: 300px;margin-bottom: 20px;">
                                     <input type="text" class="form-control" value="WEB Terminal" readonly/>
                                  </div>
                                </ng-container>
                              </div>

                              <ng-container *ngIf="!this.isWebTerminal()">
                                  <div class="row top-buffer">
                                    <div class="col-md-3">
                                      <label>Questionnaire Associated: </label>
                                    </div>
                                    <div class="col-md-9" style="width: 300px;margin-bottom: 20px;">
                                      <label>
                                        <input type="text" class="form-control" [value]="associatedQuestionnaireName" readonly/>
                                      </label>
                                    </div>
                                  </div>
                              </ng-container>

                              <ng-container *ngIf="!this.isWebTerminal()">
                                  <div class="row top-buffer">
                                    <div class="col-md-3">
                                      <label>{{'username'|translate}}</label>
                                    </div>
                                    <div class="col-md-9" style="width: 300px;margin-bottom: 20px;">
                                      <label>
                                        <input type="text" name="username" class="form-control" [value]="terminal.username"
                                               (input)="terminal.username = $event.target.value" [(ngModel)]="terminal.username" #username="ngModel"
                                               required/>
                                      </label>
                                      <div *ngIf="username.errors && (username.dirty || username.touched)"
                                           class="alert alert-danger">
                                        <div [hidden]="!username.errors.required">
                                          Username is required
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </ng-container>

                              <ng-container *ngIf="!this.isWebTerminal()">
                                  <div class="row top-buffer">
                                    <div class="col-md-3">
                                      <label>{{'password'|translate}}</label>
                                    </div>
                                    <div class="col-md-9" style="width: 300px;margin-bottom: 20px;">
                                      <label>
                                        <input type="text" name="password" class="form-control" [value]="terminal.password"
                                               (input)="terminal.password = $event.target.value" [(ngModel)]="terminal.password" #password="ngModel"
                                               required/>
                                      </label>
                                      <div *ngIf="password.errors && (password.dirty || password.touched)"
                                           class="alert alert-danger">
                                        <div [hidden]="!password.errors.required">
                                          Password is required
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </ng-container>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!this.isWebTerminal()" class="card cardForm">
                        <div class="card-header">
                            <h5><span><img class="titleBar" src="../../../assets/images/tabletIpad.png" alt="icon"></span>Registered Devices</h5>
                        </div>
                        <div class="card-body outer-container">
                            <div class="col-md-12" style="margin-bottom: 40px;width:100%;height:400px;overflow:scroll; border-width: 1px;border-color:#19A9E5;border-style: solid;border-radius:5px;">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th width="50%"><span class="icon"><i class="fas fa-tablet-alt"></i></span>Name</th>
                                        <th><span class="icon"><i class="fas fa-globe"></i></span>Mac Address</th>
                                        <th><span class="icon"><i class="far fa-calendar-alt"></i></span>Registered date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let device of devices" style="border-bottom: 2px solid #444444;align-content: center;">
                                        <td>{{device.name}}</td>
                                        <td>{{device.macAddress}}</td>
                                        <td>{{device.createdDate}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card cardForm">
                        <div class="card-header">
                            <h5 class="uploadHeaderIcon"><span><img class="titleBar" src="../../../assets/images/folder-up-icon.png" alt="icon"></span>Uploaded Files</h5>
                            <button type="button" class="uploadBtn btn btn-success" (click)="onFileToDownload()">Upload File</button>
                        </div>
                        <div class="card-body outer-container">
                            <div class="col-md-12" style="margin-bottom: 40px;width:100%;height:400px;overflow:scroll; border-width: 1px;border-color:#19A9E5;border-style: solid;border-radius:5px;">
                                <table class="table">
                                      <thead>
                                          <tr>
                                            <th width="50%">Name</th>
                                            <th>Size</th>
                                            <th style="text-align:center;">Status</th>
                                            <th>Actions</th>
                                            <th style="text-align:center;">Main Terminal File</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let item of terminal.filesToDownload" style="border-bottom: 2px solid #444444;align-content: center;">
                                            <td>
                                                <div *ngIf="item.src.includes('.png')" class="alert alert-info" role="alert"
                                                       style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span style="margin-right: 10px;color:#0aa361"><i  style="font-size: large" class="far fa-file-image"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.jpg')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span style="margin-right: 10px; color:#0aa361"><i  style="font-size: large" class="far fa-file-image"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.html')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px;color:orange;"><i  style="font-size: large" class="fab fa-html5"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.css')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px;color:dodgerblue"><i  style="font-size: large" class="fab fa-css3"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.js') && (item.src.split('.')[1].length === 2)" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px;color:yellow"><i  style="font-size: large" class="fab fa-js"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.xml')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px; color:#4a148c"><i  style="font-size: large" class="far fa-file-code"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.json') && (item.src.split('.')[1].length === 4)" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px; color:cornflowerblue"><i  style="font-size: large" class="fas fa-file"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.properties') && (item.src.split('.')[1].length === 10)" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px; color:cornflowerblue"><i  style="font-size: large" class="fa fa-code"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.mp3')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span style="margin-right: 10px; color:#be8904"><i  style="font-size: large" class="far fa-file-audio"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.wav')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px; color:#be8904"><i  style="font-size: large" class="far fa-file-audio"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.txt')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                    <span  style="margin-right: 10px; color:#00b0ff"><i  style="font-size: large" class="far fa-file-text"></i></span><strong>{{item.src}}</strong>
                                                </div>
                                                <div *ngIf="item.src.includes('.mp4')" class="alert alert-info" role="alert"
                                                     style="text-align:center;font-weight:bold;height: 22px; width:350px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                                <span  style="margin-right: 10px; color:#be8904"><i  style="font-size: large" class="far fa-file-video"></i></span><strong>{{item.src}}</strong>
                                              </div>
                                            </td>
                                            <td style="vertical-align: middle;"><span class="glyphicon glyphicon-floppy-disk"
                                                                                      aria-hidden="true"></span><strong>{{item.size}}{{item.unit}}</strong></td>
                                            <td>
                                              <div class="alert alert-success" role="alert"
                                                   style="text-align:center;font-weight:bold;height: 22px; width:auto;padding-top:1px;font-size: 14px;margin-top:25px;">
                                                <span class="glyphicon glyphicon-open" aria-hidden="true"></span>Uploaded
                                              </div>
                                            </td>
                                            <td nowrap style="vertical-align: middle;">
                                              <button type="button" class="btn btn-danger btn-xs"
                                                      (click)="onRemove(item.src);">
                                                <span class="glyphicon glyphicon-trash"></span> Remove
                                              </button>
                                            </td>
                                            <td  align="center">
                                                <ng-container *ngIf="item.src.endsWith('.xml') || item.src.endsWith('.json')">
                                                        <input style="width:30px;height:30px;margin-top:15px;" type="radio" class="form-check-input" name="MainFile"
                                                              [checked]="this.terminal.src === item.src" (click)="onCheckBoxClick(item,$event.srcElement)">
                                                </ng-container>
                                            </td>
                                          </tr>
                                      </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                  <ng-container *ngIf="!this.isWebTerminal()">
                    <div class="card cardForm">
                        <div class="card-header">
                            <h5><span><img alt="icon" class="titleBar" src="../../../assets/images/actionPostSynchro.png"></span>Post-Synchro Actions</h5>
                        </div>
                        <div class="col-md-12 card">
                            <div class="card-body">
                              <label>
                                <input type="checkbox" name="sms" value="sms" (click)="onPostSynchroCheckBoxClick(item,$event.srcElement)"
                                       [checked]="evaluate('sms')">
                              </label> Add Post Synchro SMS<br>
                              <label>
                                <input type="checkbox" name="email" value="email" (click)="onPostSynchroCheckBoxClick(item,$event.srcElement)"
                                       [checked]="evaluate('email')">
                              </label> Add Post Synchro Email <br>
                              <!--<label>
                                <input type="checkbox" name="socialwall" value="socialwall"
                                       (click)="onPostSynchroCheckBoxClick(item,$event.srcElement)" [checked]="evaluate('socialwall')">
                              </label> Make Photo Available On Social-Wall <br>-->
                              <label>
                                <input type="checkbox" name="transformationPhoto" value="transformation"
                                       (click)="onPostSynchroCheckBoxClick(item,$event.srcElement)" [checked]="evaluate('transformation')">
                              </label> Add Post Synchro Transformation <br>
                              <!--<label>
                                <input type="checkbox" name="cloneRespondent" value="clone"
                                       (click)="onPostSynchroCheckBoxClick(item,$event.srcElement)" [checked]="evaluate('clone')">
                              </label> Add Post Synchro Clone <br>-->
                            </div>
                        </div>
                    </div>

                      <div class="card cardForm">
                          <div class="card-header">
                              <h5><span><img alt="icon" class="titleBar" src="../../../assets/images/PhotoWGallery.png"></span>Gallery</h5>
                          </div>
                          <div class="col-md-12 card">
                              <div class="card-body">
                                  <label>
                                      <input type="checkbox" name="gallery" value="gallery" (click)="setTerminalAsGallery(item,$event.srcElement)"
                                             [checked]="evaluate('gallery')">
                                  </label> Set Terminal As Gallery<br>

                                  <ng-container *ngIf="evaluate('gallery')">
                                      <div class="row top-buffer">

                                          <div class="col-md-3">
                                              <ngx-select [allowClear]="false"
                                                          [placeholder]=extractSelectedValue()
                                                          [items]=getDataSrcTerminalList()
                                                          (select)="setSrcDataTerminal($event)"
                                                          (data)="refreshValue($event)"
                                              ></ngx-select>
                                          </div>
                                      </div>
                                  </ng-container>

                              </div>
                          </div>
                      </div>

                    <div  class="card cardForm"> <!--*ngIf="this.terminal.clone!=null || this.cloneChecked"-->
                        <div class="card-header">
                            <h5 ><span><img class="titleBar" src="../../../assets/images/clone.png" alt="icon"></span>Clone Mapping</h5>
                        </div>
                        <div class="card col-md-12 cardPostSynchro">
                            <div class="card-body outer-container">
                              <table>
                                <thead>
                                <!--<tr>
                                  <td>
                                    Respondent ID Question No:
                                  </td>
                                  <td>
                                    <input (ngModelChange)="onValueUpdate($event,true)" name="respQuestionNo" [(ngModel)]="this.terminal.clone.respondentNoQuestion">
                                  </td>
                                </tr>-->
                                <tr>
                                    <td>
                                        Source
                                    </td>
                                    <td>
                                        Destination
                                    </td>
                                    <td>
                                        Optional
                                    </td>
                                    <!--<td>
                                        Referenced Project
                                    </td>
                                    <td>
                                        Referenced PID
                                    </td>
                                    <td>
                                        Referenced QID
                                    </td>
                                    <td>
                                        Referenced TID
                                    </td>-->
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let entry of this.terminal.clone.questionMap">
                                  <td>{{entry.getSrcQNo()}}</td>
                                  <td>{{entry.getDestQNo()}}</td>
                                    <td><input  type="checkbox" [checked]="entry.getOptional()"></td>
                                    <!--<td><input  type="checkbox" [checked]="entry.getReferencedProject()!=null"></td>
                                    <td *ngIf="entry.getReferencedProject()!=null">{{entry.getReferencedProject().getProjectId()}}</td>
                                    <td *ngIf="entry.getReferencedProject()!=null">{{entry.getReferencedProject().getQuestionnaireId()}}</td>
                                    <td *ngIf="entry.getReferencedProject()!=null">{{entry.getReferencedProject().getTerminalId()}}</td>-->
                                  <td>
                                    <button type="button" class="btn btn-danger " (click)="removeMapEntry(entry)"><span><i class="far fa-trash-alt"></i></span></button>
                                  </td>
                                </tr>
                                <tr>
                                  <td><label>
                                    <input type="number" class="no-spinners" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="srcQuestion" name="srcQuestion">
                                  </label></td>
                                  <td><label>
                                    <input type="number" class="no-spinners" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="destQuestion" name="destQuestion">
                                  </label></td>
                                  <td><label>
                                        <input  type="checkbox" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="refOptional" name="Optional">
                                  </label></td>
                                  <!--<td><label>
                                    <input  type="checkbox" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="refProject" name="referenced Project">
                                  </label></td>
                                    <td *ngIf="refProject"><label>
                                        <input type="number"  class="no-spinners" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="refProjectID" name="Referenced Project ID">
                                    </label></td>
                                    <td *ngIf="refProject"><label>
                                        <input  type="number"  class="no-spinners"(ngModelChange)="onValueUpdate($event)" [(ngModel)]="refQuestID" name="Referenced Questionnaire ID">
                                    </label></td>
                                    <td *ngIf="refProject"><label>
                                        <input  type="number"  class="no-spinners" (ngModelChange)="onValueUpdate($event)" [(ngModel)]="refTermID" name="Referenced Terminal ID">
                                    </label></td>-->
                                  <td>
                                    <button type="button" class="btn btn-success" (click)="onAddMapping()" data-toggle="button">Add</button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                                  <!-- <p>Questionnaire to be cloned to</p>
                                   <div class="btn-group">
                                     <button type="button" class="btn btn-secondary">{{(this.terminal.clone.questionnaireName != null) ?this.terminal.clone.questionnaireName:"Select a questionaire"}}</button>
                                     <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       <span class="sr-only">Toggle Dropdown</span>
                                     </button>
                                     <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                       <a class="dropdown-item hand" *ngFor="let questionnaire of project.questionnaires" (click)="cloneQuestionnaireSelected(questionnaire)">{{questionnaire.title}}</a>
                                     </div>
                                   </div>-->
                            </div>
                        </div>
                    </div>

                    <div class="card cardForm">
                        <div class="card-header">
                                <h5><span><img alt="icon" class="titleBar" src="../../../assets/images/config.png"></span>More Settings</h5>
                        </div>
                        <div class="card col-md-12">
                            <div class="card-body">

                              <div class="card-header subHeader">
                                <h6><span><img alt="icon" class="subTitleBar" src="../../../assets/images/outlook.png"></span> Mail</h6>
                              </div>
                              <div class="card col-md-12">
                                <div class="card-body">
                                    <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;" (click)="onMailComposerClick()">
                                        <span><i class="fas fa-envelope" data-toggle="tooltip" data-placement="top" title="Mail Composer"></i></span>
                                    </button>
                                    <!--TODO: remove the below commented section upon confirmation -->
                                  <!--<button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;" (click)="onMailClick()">
                                    <span><i class="fas fa-envelope" data-toggle="tooltip" data-placement="top" title="Create Email"></i></span>
                                  </button>
                                  <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;"
                                          (click)="showEmailPreview()" data-toggle="tooltip" data-placement="top" title="Preview Email"><span><i
                                    class="far fa-eye"></i></span></button>
                                  <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;"
                                          (click)="onEmailSendClick()" data-toggle="tooltip" data-placement="top" title="Test Send Email"><span><i
                                    class="fas fa-at"></i></span></button>

                                    <button type="button" class="btn btn-lg btn-danger col-md-2" style="margin-right: 10px;"
                                            (click)="removeEmailDefinition()" data-toggle="tooltip" data-placement="top" title="Delete Email Definition"><span><i
                                            class="fas fa-times"></i></span></button>-->
                                </div>
                              </div>

                              <br/>
                              <br/>
                              <div class="card-header subHeader">
                                <h6><span><img class="subTitleBar" src="../../../assets/images/iPhoneSms.png"></span>Sms</h6>
                              </div>

                              <div class="card col-md-12">
                                <div class="card-body">
                                  <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;" (click)="onSmsClick()"
                                          data-toggle="tooltip" data-placement="top" title="Create SMS"><span><i class="fas fa-sms"></i></span>
                                  </button>
                                  <button type="button" class="btn btn-lg btn-primary col-md-2" style="margin-right: 10px;"
                                          (click)="onSmsSendClick()" data-toggle="tooltip" data-placement="top" title="Test Send SMS"><span><i
                                    class="fas fa-comments"></i></span></button>

                                    <button type="button" class="btn btn-lg btn-danger col-md-2" style="margin-right: 10px;"
                                            (click)="removeSMSDefinition()" data-toggle="tooltip" data-placement="top" title="Delete SMS Definition"><span><i
                                            class="fas fa-times"></i></span></button>
                                </div>
                              </div>

                                <br/>
                                <br/>
                                <div class="card-header subHeader">
                                    <h6><span><img alt="icon" class="subTitleBar" src="../../../assets/images/movieEditor.png"></span> FFMPEG</h6>
                                </div>

                                <div class="card col-md-12">
                                    <div class="card-body">
                                        <ffmpeg></ffmpeg>
                                    </div>
                                </div>

                                <br/>
                                <br/>
                                <div class="card-header subHeader">
                                    <h6><span><img alt="icon" class="subTitleBar" src="../../../assets/images/imageEditor.png"></span>ImageMagicks</h6>
                                </div>

                                <div class="card col-md-12">
                                    <div class="card-body">
                                        <imageMagicks></imageMagicks>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card cardForm">
                        <div class="card-header">
                            <h5><span><img at="icon" class="titleBar" src="../../../assets/images/socialMedia.png"></span>Social Media Content Definition</h5>
                        </div>
                        <div class="card col-md-12">
                            <div class="card-body">
                              <div class="card col-md-12">
                                <div class="card-body">
                                  <button type="button" class="btn btn-lg btn-outline-primary col-md-2" style="margin-right: 10px;" (click)="onFacebookDefinitionClick()"
                                          data-toggle="tooltip" data-placement="top" title="Create Facebook Post Definition"><span style="color: #0b51c5"><i class="fab fa-facebook-square"></i></span>
                                  </button>
                                  <button type="button" class="btn btn-lg btn-outline-primary col-md-2" style="margin-right: 10px;"
                                          (click)="onTwitterDefinitionClick()" data-toggle="tooltip" data-placement="top" title="Create Twitter Post Defition"><span style="color: #00b0ff;"><i class="fab fa-twitter-square"></i></span></button>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div class="card cardForm">
                        <div class="card-header">
                            <h5><span><img class="titleBar" src="../../../assets/images/197.png" alt="icon"></span>Microsite Appearance Configurator</h5>
                        </div>
                        <div class="card-body">
                            <microsite-configurator [project]="project" [questionnaire]="selectedQuestionnaire" [terminal]="terminal"></microsite-configurator>
                        </div>
                    </div>
                  </ng-container>
                  <div class="row top-buffer">
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-primary btn-lg" style="margin-top:10px;"><span style="margin-right:10px;"><i
                        class="fas fa-save"></i></span>{{'save'|translate}}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          <footer class="w3-container w3-blue">
            <h5></h5>
          </footer>
        </div>
      </div>

      <add-file-to-download-dialog [definedTerminalType]="definedClient" [hide]="_hideFileToDownloadDialog" [project]="project"
                                   [filesToDownload]="terminal.filesToDownload" (on-new-file-to-download)="addFileToDownload($event)"
                                   (on-cancel-file-to-download)="hideFileToDownloadDialog()" (ErrorUpload)="onErrorUpload($event)"></add-file-to-download-dialog>
      <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>
      <!--<create-email-dialog [hide]="_hideCreateEmailDialog" [project]="project" [refEmail]="email"
                           (NewEmailCreate)="onEmailCreate($event)" (CancelCreateEmail)="hideCreateEmailDialog()"
                           [questionnaire]="selectedQuestionnaire" [terminal]="terminal"></create-email-dialog>-->
      <content-preview-dialog [isEmail]="true" [title]="this.title" [langArr]="this.selectedQuestionnaire.languages" [terminal]="this.terminal" [questionnaire]="this.selectedQuestionnaire"></content-preview-dialog>
      <create-sms-dialog [hide]="_hideSmsCreateDialog" (NewSmsCreate)="onSmsCreate($event)"
                         (CancelSmsEmail)="hideCreateSmsDialog()" [project]="project" [terminal]="terminal"
                         [questionnaire]="selectedQuestionnaire"></create-sms-dialog>
      <send-test-sms-dialog [hide]="_hideTestSendSmsDialog"
                            (closeSmsTest)="hideSmsSendDialog()" [langArr]="this.selectedQuestionnaire.languages" [terminal]="this.terminal" [questionnaire]="this.selectedQuestionnaire"></send-test-sms-dialog>
      <send-test-email-dialog [hide]="_hideTestSendEmailDialog"
                              (CloseEmailTest)="hideEmailSendDialog()" [langArr]="this.selectedQuestionnaire.languages" [terminal]="this.terminal" [questionnaire]="this.selectedQuestionnaire"></send-test-email-dialog>
      <file-chooser [context]="_currentContext"></file-chooser>
      <socialMediaContentDefinition [facebookDef]="isFacebookDefinition" [project]="project" [terminal]="terminal" (confPosted)="hideSocialDefinitionDialog()"></socialMediaContentDefinition>
      <emailComposer [project]="project" [questionnaire]="selectedQuestionnaire" [terminal]="terminal" [terminalTypeId]="getTerminalTypeID()"></emailComposer>
      </div>`,
    styles: [`
        .uploadHeaderIcon{float:left;}
        .uploadBtn{float:right;}
        .icon{margin-right:5px;}
        .ng-valid[required], .ng-valid.required  {
            border: 2px solid #42A948;} /* green */
          img {height:70px;}
          .terminalIcon{height:150px;}
        .w3-container,.w3-panel{padding:0;}
        .header-container{background:linear-gradient(0deg,rgba(59,139,239,1) 0%,rgba(11,97,206,1) 100%);border-top-left-radius:5px;border-top-right-radius:5px;}
        h4.headerTitle{text-align: center;color:#ffffff;margin-top:20px;}
        .titleBar{height:26px;margin-right:5px;}
        .titleBarIcon{height:40px;}
        .subTitleBar{height:24px;margin-right:5px;}
        .card-header{ background-color:rgb(1,119,215);color:#ffffff;}
        .cardForm{margin-top:30px;border-color:#19A9E5;}
        .subHeader{height:40px;background-color:rgb(13,174,235);color:#ffffff;}
        .cardPostSynchro{padding: 0;}

        .no-spinners::-webkit-outer-spin-button,
        .no-spinners::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .input-group-text {
            background: -webkit-linear-gradient(top, #648bf5, #2866f2);
            background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
            border-top: 1px solid #5a82eb;
            border-bottom: 1px solid #1758e7;
            color: #ffffff;
        }

        /* START OUTER CONTAINER STYLES */
        .outer-container {
            background-color: #273349;
            border-radius: 0.225rem;
            box-shadow: 0 5px 10px rgba(12,16,31,0.4);
            margin: auto;
            width:100%;
        }

        :root {
            --body-background: #1c223b;
            --body-text: #ffffff;
            --container-background: #273349;
            --table-background: #1c223b;
            --table-background-hover: #151b31;
            --table-text: #e2e2e2;
            --priority-200: #d6a13f;
            --priority-300: #4480e7;
            --priority-600: #40c587;
            --delete-background: #242c4c;
            --delete-color: #909090;
            --delete-hover: #ff0000;
        }



        table {
            color: #e2e2e2;
            font-size: 0.875rem;
            padding: 0.625rem;
            width: 100%;
        }
        table th {
            font-size: 1rem;
        }
        table th, table td {
            padding: 0.9375rem;
            text-align: left;
        }
        table tbody tr {
            background-color: #1c223b;
        }
        table tbody tr:hover {
            background-color:  #151b31;
            box-shadow: 0 3px 5px rgba(0,0,0,0.2);
        }
        table tbody tr td:first-of-type {
            border-top-left-radius: 0.3125rem;
            border-bottom-left-radius: 0.3125rem;
        }
        table tbody tr td:last-of-type {
            border-top-right-radius: 0.3125rem;
            border-bottom-right-radius: 0.3125rem;
            text-align: center;
        }
        table tbody tr.priority-200 td:first-of-type {
            border-left: 0.3125rem solid #d6a13f;
        }
        table tbody tr.priority-300 td:first-of-type {
            border-left: 0.3125rem solid #4480e7;
        }
        table tbody tr.priority-600 td:first-of-type {
            border-left: 0.3125rem solid #40c587;
        }
        table tbody tr td .fa-circle {
            transform: scale(0.7);
        }
        table tbody tr.priority-200 td .fa-circle {
            color: #d6a13f;
        }
        table tbody tr.priority-300 td .fa-circle {
            color: #4480e7;
        }
        table tbody tr.priority-600 td .fa-circle {
            color: #40c587;
        }
        .delete-btn {
            cursor: pointer;
            background-color: #242c4c;
            background-color: transparent;
            border: 0;
            border-radius: 0.125rem;
            color:  #909090;
            font-size: 1.1rem;
            opacity: 0.2;
            padding: 0.3125rem 0.625rem;
        }
        .delete-btn:hover {
            color: #ff0000;
        }
        .delete-btn:focus {
            outline: 0;
        }
        table tbody tr:hover .delete-btn {
            opacity: 1;
        }

        /* KEYFRAMES */
        /* Fade In Webpage Keyframe */
        @keyframes fadeInPage {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }


        /* MEDIA QUERIES */
        @media(max-width: 768px) {
            .outer-container {
                padding: 1.25rem;
            }
            h1 {
                margin: 0;
            }
        }
        @media(max-width: 668px) {
            table th:nth-of-type(3), table td:nth-of-type(3) {
                display: none;
            }
        }
  `]

})
export class QuestionnaireNodeComponent implements  OnInit, OnChanges {

    @Input() terminal: Terminal;
    @Input() project: Project;

    @Output() DeviceSelected: EventEmitter<Terminal> = new EventEmitter<Terminal>();
    @Output() breadCrumbLink:EventEmitter<Project|Questionnaire|Terminal> = new EventEmitter();
    @ViewChild (CreateEmailComponent) private createEmailComponent: CreateEmailComponent;
    @ViewChild (CreateSmsComponent) private createSmsComponent: CreateSmsComponent;
    @ViewChild (FileChooserComponent) private fileChooser:FileChooserComponent;
    @ViewChild (ImportDuplicateModalComponent) private importDuplicate:ImportDuplicateModalComponent;
    @ViewChild (SocialMediaContentDefinitionComponent) private socialContentDefinition:SocialMediaContentDefinitionComponent;
    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;
    @ViewChild (ContentPreviewComponent) private contentPreviewComponent:ContentPreviewComponent;
    @ViewChild (EmailComposerComponent) private emailComposerComponent:EmailComposerComponent;

    clientType = ['Select a client type', 'iBrand Windows', 'iBrand Android','Web'];
    active = true;
    languages = ['En', 'Fr']; // un-necessary

    metadata = [];

    devices = [];

    private database:Database;

    private isFacebookDefinition = true;

    private value: any = {};
    private definedClient = 0;
    private _hideFileToDownloadDialog = true;
    private _hideInfoModal = true;
    private _hideCreateEmailDialog = true;
    private _hideEmailPreviewDialog = true;
    private _hideSmsCreateDialog = true;
    private _hideTestSendSmsDialog = true;
    private _hideTestSendEmailDialog = true;

    private _fileToDownload: FileToDownload;

    private _srcDataTerminalList = new Map<string, Terminal>();

    // private selectedQuestionnaireID:number=0;

    private selectedQuestionnaire: Questionnaire;

    private associatedQuestionnaireName: string;

    private email: Email;

    private terminalForm: FormGroup;

    private emailContentPreview: ContentPreview;

    // private cloneChecked:boolean;

    private srcQuestion = 0;

    private destQuestion = 0;

    // private respondentQuestionNo;

    private _currentContext:CurrentContext;

    private contentCreation = false;

    private title = 'Email Preview';

    private refProject = false;

    refProjectID = 0;

    refQuestID = 0;

    refTermID = 0;

    refOptional = false;


    /*private _terminalTypeID = 0;*/
    constructor(private _projectService: ProjectService, constants: Constants, private _deviceService: DeviceDetectorService, private refElement: ElementRef,private _refreshService:SharedRefreshService) {
        // this.emailContentPreview = new EmailPreview();
    }


    onFileToDownload() {

        if (this.terminal.type === '') {
          this.genericModal.defineModal('You must specify the type of your terminal before adding files!','Terminal Node',101);
        } else {
            this._fileToDownload = new FileToDownload();
            this._hideFileToDownloadDialog = false;
        }
    }

    private isWebTerminal() {
        if(TerminalUtil.getTerminalTypeId(this.terminal.type)===3) {
            return true;
        }
        return false;
    }
    hideFileToDownloadDialog() {
        this._fileToDownload = null;
        this._hideFileToDownloadDialog = true;
    }

    hideSmsSendDialog() {
        this._hideTestSendSmsDialog = true;
    }

    hideEmailSendDialog() {
        this._hideTestSendEmailDialog = true;
    }

    addFileToDownload(fileToDownload: Array<FileToDownload>) {
        this.terminal.filesToDownload = fileToDownload ; // non utiliser à enlever eventuellment
        this.hideFileToDownloadDialog();
    }

    onErrorUpload(val:string) {
        this.genericModal.defineModal(val,'Terminal Node',350);
        this._hideInfoModal=false;
    }


    ngOnInit(): void {

        this._currentContext = new CurrentContext();
        this._currentContext.project = this.project;
        this._currentContext.tId = this.terminal.id;
        this._currentContext.qId = this.terminal.associatedQuestionnaireId;
        this._currentContext.terminalTypeId = TerminalUtil.getTerminalTypeId(this.terminal.type);

        this.database = new Database('');
        this.database.pId = this.project.id;
        this.database.qId = this.terminal.associatedQuestionnaireId;
        this.database.tId = this.terminal.id;
        this.database.terminalType = TerminalUtil.getTerminalTypeId(this.terminal.type);

        for (const item of this.project.questionnaires) {
            if (item.id === this.terminal.associatedQuestionnaireId) {
                this.selectedQuestionnaire = item;
            }
        }

        this.getDeviceListUsedForThisTerminal(this.terminal.id);

        this.setTerminaltype();


        // If an email is already defined get it
        // this.getEmailModel('En');


        /*for(let item of this.project.questionnaires) {
            if (item.id == this.terminal.associatedQuestionnaireId)
            {
                this.associatedQuestionnaireName =item.title;
            }

        }*/

        /*this.form = new ValidationManager({
            'username'    : 'required|pattern:[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*',
            'password'    : 'required|rangeLength:4,8'
        });*/



      this.getAssociatedQuestionnaireName();

      this.prepareListOfSrcTerminal();


       // this.form.setErrorMessage('username', 'pattern', 'Pattern must be part of this family: [A-Za-z0-9.-_]');
    }


    // methode a revoir
    /*private getEmailModel(lang: string) {

        this.updateSelectedQuestionnaireID();
        this._projectService.getEmailModel(this.project.id, this.selectedQuestionnaire.id, this.definedClient, lang)  // TODO: critere de langue a revoir
            .then(data => {
                    this.email = data;
                },
                error => console.log('OK'));
    }*/




    private setTerminaltype() {
        if (this.terminal.type === 'Android') {
            this.definedClient = 2;
        } else if (this.terminal.type === 'Windows') {
            this.definedClient = 1;
             } else {
            this.definedClient = 0;
             }

             console.log('Defined client type: '+ this.definedClient);
    }


    onUpdate() {

       // if(this.form.isValid()) {


            switch (this.terminal.type) {
                case 'Windows' :
                    this.definedClient = 1;   // windows 10 based client(terminal)
                    break;
                case 'Android' :
                    this.definedClient = 2; // android based client(terminal)
                    break;
            }

           /* this.terminal.isGallery = this._terminalIsGallery;
            this.terminal.dataSrcTId = this._dataSrcTerminalId;*/


            // update questionnaireID
            this.updateSelectedQuestionnaireID();

            this._projectService.updateTerminalNode(this.terminal, this.project.id, this.selectedQuestionnaire.id, this.definedClient).subscribe(
                (msg:number) => {
                    console.log(msg);
                  // this.showGenericAlertMsgBox('Changes to the terminal node have been saved successfully !','Terminal Node',200);
                    if(msg === 350) {
                        this.genericModal.defineModal('Failed to update terminal!','Terminal Node',350);
                    } else {
                        this.genericModal.defineModal('Changes to the terminal node have been saved successfully !', 'Terminal Node', 200);
                    }
                  this._hideInfoModal=false;

                });
    }

    public onSwitchTerminal(terminal:Terminal) {
      this.terminal = terminal;
      this.setTerminaltype();

      for (const item of this.project.questionnaires) {
        if (item.id === this.terminal.associatedQuestionnaireId) {
          this.selectedQuestionnaire = item;
        }
      }
    }


    onRemove(fileToRemove: string) {
      // TODO: Try to push files on confirmation
        this._projectService.removeUploadedFile(fileToRemove).then(
            (msg) => {
                console.log(msg);
            })
            .catch();
        for (let i = 0 ; i < this.terminal.filesToDownload.length ; i++) {
            if (this.terminal.filesToDownload[i].src === fileToRemove) {
                this.terminal.filesToDownload.splice(i, 1);
            }
        }
    }

    onCheckBoxClick(item, input: HTMLInputElement) {
        const re = /^.*.xml$/g;
        const re2 = /^.*.json$/g;
        // if (item.src.toString().search(re) !== -1 || item.src.toString().search(re2) !== -1) {
            // item.mainFile = !(item.mainFile);
            this.terminal.src = item.src;
        /*} else {

          this.genericModal.defineModal('Only XML file of JSON file can be selected as main file./n Seulement un fichier XML ou JSON peut etre marque comme fichier principal.','Terminal Node',101);
            input.checked = false;
        }*/

    }

  onPostSynchroCheckBoxClick(item, input: HTMLInputElement) {

      switch(input.value) {
        case 'sms': if(input.checked) {this.terminal.actionPostSynchro.push(PostSynchroActions.SMS);} else {const idx = this.terminal.actionPostSynchro.findIndex(a=>a===PostSynchroActions.SMS);this.terminal.actionPostSynchro.splice(idx,1);} break;
        case 'email':if(input.checked) {this.terminal.actionPostSynchro.push(PostSynchroActions.Email);} else {const idx = this.terminal.actionPostSynchro.findIndex(a=>a===PostSynchroActions.Email);this.terminal.actionPostSynchro.splice(idx,1);} break;
        case 'socialwall':if(input.checked) {this.terminal.actionPostSynchro.push(PostSynchroActions.SocialWall);} else {const idx = this.terminal.actionPostSynchro.findIndex(a=>a===PostSynchroActions.SocialWall);this.terminal.actionPostSynchro.splice(idx,1);} break;
        case 'transformation':if(input.checked) {this.terminal.actionPostSynchro.push(PostSynchroActions.Transformation);} else {const idx = this.terminal.actionPostSynchro.findIndex(a=>a===PostSynchroActions.Transformation);this.terminal.actionPostSynchro.splice(idx,1);} break;
        // case 'clone':if(input.checked) {this.terminal.actionPostSynchro.push(PostSynchroActions.Clone);this.cloneChecked = true;this.terminal.clone = new Clone('');} else {this.terminal.actionPostSynchro.splice(this.terminal.actionPostSynchro.indexOf(PostSynchroActions.Clone,1));this.cloneChecked=false;} break;
      }
  }

  evaluate(item:string) {

      let val: boolean;
      switch (item) {
        case 'sms': val = this.terminal.actionPostSynchro.indexOf(PostSynchroActions.SMS) > -1;break;
        case 'email': val = this.terminal.actionPostSynchro.indexOf(PostSynchroActions.Email) > -1;break;
        case 'socialwall': val = this.terminal.actionPostSynchro.indexOf(PostSynchroActions.SocialWall) > -1;break;
        case 'transformation': val = this.terminal.actionPostSynchro.indexOf(PostSynchroActions.Transformation) > -1;break;
        case 'clone': val = this.terminal.actionPostSynchro.indexOf(PostSynchroActions.Clone) > -1;break;
        case 'gallery': val = this.terminal.isGallery;break;
      }


    return val;
  }

    onOk() {
        this._hideInfoModal = true;

        // TODO: Think of a better way to handles popups and events type.
        if(!this.contentCreation) {
            this._refreshService.refresh(true);
        } else {
            this.contentCreation = false;
            return;
        }
    }

    selected(value: any): void {
        this.terminal.type = TerminalUtil.extractTerminal(value);
        this.DeviceSelected.emit(this.terminal);
        console.log('This is the working class');

    }

    setSrcDataTerminal(value:any):void {
        if(typeof value === 'string') {
            this.terminal.dataSrcTId = this._srcDataTerminalList.get(value).id;
        }
        if(typeof value === 'number') {
            this.terminal.dataSrcTId = value;
        }
    }


    refreshValue(value: any): void {

        this.value = value;
    }


    removeTerminal(value: number) {

        this.updateSelectedQuestionnaireID();
        this._projectService.removeTerminal(value, this.project.id, this.selectedQuestionnaire.id).subscribe(    // pour le moment on a juste un seul questionnaireProject serveur
            (data) => {
                if(data === 100) {
                    console.log(data);
                    // this.showGenericAlertMsgBox('Terminal node has been removed successfully.','Terminal Node',200);
                    this.genericModal.defineModal('Terminal node has been removed successfully.','Terminal Node',200);
                } else if(data === 102) {
                    console.log(data);
                    // this.showGenericAlertMsgBox('An Error has occurred while removing terminal','Terminal Node',301);
                    this.genericModal.defineModal('An Error has occurred while removing terminal','Terminal Node',301);
                } else if(data === 404) {
                    console.log(data);
                    // this.showGenericAlertMsgBox('Terminal to delete was not found. It was probably removed','Terminal Node',250);
                    this.genericModal.defineModal('Terminal to delete was not found. It was probably removed','Terminal Node',250);
                }
                this._hideInfoModal =false;
            },
            error => console.log('Error removing questionnaire'));
    }

  /*onMailPreview() {
      this._projectService.getEmailPreview(this.project.id,this.selectedQuestionnaire.id,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type)).subscribe(
        (emailHtml) => {
          console.log(emailHtml);
          // emailHtml as emailPreview;
          this.emailContentPreview.setHtmlcontent(emailHtml);
        });
  }*/

    showEmailPreview() {
     // this._hideEmailPreviewDialog=false;
      this.contentPreviewComponent.showDialog();
    }

    private  getAssociatedQuestionnaireName() {
        for (const item of this.project.questionnaires) {
            if (item.id === this.terminal.associatedQuestionnaireId) {
                this.associatedQuestionnaireName = item.name;
                console.log(this.associatedQuestionnaireName);
            }

        }

    }

    private getTerminalTypeID():number {
            return this.terminal.type === 'Android' ? 2 : 1;
    }

    public  onMailClick() {
        // If an email is already defined get it
        // this.getEmailModel('En');
        this._hideCreateEmailDialog = false;
    }

    public onSmsClick() {
      this._hideSmsCreateDialog = false;

    }

    // TODO: Deprecated
    public onEmailCreate(email: Email) {
        this._projectService.createEmail(email, this.project.id,this.selectedQuestionnaire.id,this.terminal.id, this.definedClient).subscribe(
            (msg) => {
                console.log(msg);
                // this.showGenericAlertMsgBox('Email has  been saved successfully !','Mail Creator',200);
                this.genericModal.defineModal('Email has  been saved successfully !','Mail Creator',200);
                this._hideInfoModal = false;
                this.hideCreateEmailDialog();
                this.contentCreation  = true;
            });

    }


    /*public  onMailPreview() {
        this._projectService.generateEmailPreview(this.project.id, this.selectedQuestionnaire.id, this.definedClient, 'En', true).then(
            (preview) => {
                console.log(preview.emailHtml);
                this._htmlContent = preview.emailHtml;
                this._hideEmailPreviewDialog = false;
            })
            .catch();
    }*/

    private onSmsCreate(sms:Sms) {
      this._projectService.createSms(sms, this.project.id, this.selectedQuestionnaire.id, this.terminal.id, this.definedClient).subscribe(
        (msg) => {
          console.log(msg);
          // this.showGenericAlertMsgBox('SMS has been saved successfully !','Terminal Node',200);
          this.genericModal.defineModal('SMS has been saved successfully !','Terminal Node',200);
           this._hideInfoModal = false;
           this.hideCreateSmsDialog();
            this.contentCreation = true;
        });

    }

   public onSmsSendClick() {
      this._hideTestSendSmsDialog = false;
   }

  public onEmailSendClick() {
    // this._hideTestSendEmailDialog = false; // TODO; Deactivated
  }

  /* public onSmsTestSend(number:string) {
     this._projectService.sendSMS(this.project.id, this.selectedQuestionnaire.id,this.terminal.id,this.terminal.type==='Android'?2:1,number,null).subscribe(
       (msg) => {
           this.contentCreation = true;
         if(Number(msg.valueOf()) === 100) {
               this.showGenericAlertMsgBox('Test SMS sent successfully !','Terminal Node',200);
           } else if(Number(msg.valueOf()) === 102) {
               this.showGenericAlertMsgBox('An error has occurred while sending SMS!','Terminal Node',102);
           }
           this._hideTestSendSmsDialog = true;
       });
   }*/

  /*public onEmailTestSend(emailAddr:string) {
    this._projectService.sendEmail(this.project.id, this.selectedQuestionnaire.id,this.terminal.id,this.terminal.type==='Android'?2:1,emailAddr,'en',null).subscribe(
      (msg) => {
        this.contentCreation = true;
          if(msg === 100) {
              this.showGenericAlertMsgBox('Test Email sent successfully !','Terminal Node',200);
          } else if(msg === 102) {
              this.showGenericAlertMsgBox('An error has occurred while pushing email! Make sure you have defined an email before test sending it.','Terminal Node',msg);
          }
        this._hideTestSendEmailDialog = true;
      });
  }*/




    private hideCreateEmailDialog() {
        this._hideCreateEmailDialog = true;
    }

    private hideCreateSmsDialog() {
      this._hideSmsCreateDialog = true;
    }

    /*public hideEmailDialog() {
        this._hideEmailPreviewDialog = true;
    }*/

    private updateSelectedQuestionnaireID() {
        for (const item of this.project.questionnaires) {
            if (item.id === this.terminal.associatedQuestionnaireId) {
                this.selectedQuestionnaire = item;
            }
        }
    }

  removeMapEntry(obj) {
    console.log(this.terminal.clone.questionMap.length);
    this.terminal.clone.questionMap.splice(this.terminal.clone.questionMap.indexOf(obj),1);
  }

  onAddMapping() {
      if(typeof(this.srcQuestion)!== 'number') {
        console.log('This is not a number');
      }
      if(this.terminal.clone == null) {
          this.terminal.clone = new Clone();
      }
      if(this.refProject) {
            this.terminal.clone.questionMap.push(new CloningStructure(this.srcQuestion,this.destQuestion,this.refOptional,new CloneReferencedProject(this.refProjectID,this.refQuestID,this.refTermID)));
      } else {
          this.terminal.clone.questionMap.push(new CloningStructure(this.srcQuestion,this.destQuestion,this.refOptional,null));
      }
  }

  cloneQuestionnaireSelected($event: Questionnaire) {
    this.terminal.clone.projectIdRef = $event.projectId;
    this.terminal.clone.questionnaireName = $event.name;
    this.terminal.clone.questionnaireIdToBeClonedTo =$event.id;
  }

  onValueUpdate(arg:number,respNo:boolean=false) {

      if(isNaN(arg)) {
          this.genericModal.defineModal('Field only takes number type','Terminal',250);
          this._hideInfoModal=false;
      }
      if(respNo) {
        this.terminal.clone.respondentNoQuestion = arg;
      }
  }

  onImport($event: MouseEvent) {
    this.fileChooser.toggleFileChooser('projects');
    this.fileChooser.setTarget('terminal');
  }


  ngOnChanges(changes: SimpleChanges): void {
      if(this._currentContext == null) {
        this._currentContext = new CurrentContext();
      }

    this._currentContext.project = this.project;
    this._currentContext.tId = this.terminal.id;
    this._currentContext.qId = this.terminal.associatedQuestionnaireId;
    this._currentContext.terminalTypeId = TerminalUtil.getTerminalTypeId(this.terminal.type);
    this.getDeviceListUsedForThisTerminal(this.terminal.id);
  }

  private generateBreadCrumb():(Project|Questionnaire|Terminal)[] {
    const crumbs:(Project|Questionnaire|Terminal)[] = [];

    crumbs.push(this.project);
    crumbs.push(this.selectedQuestionnaire);
    crumbs.push(this.terminal);

    return crumbs;
  }

  onBreadCrumbLink(node: Project | Questionnaire | Terminal) {
    this.breadCrumbLink.emit(node);
  }

  onFacebookDefinitionClick() {
    this.isFacebookDefinition = true;
    this.socialContentDefinition.hideDialog();
  }


  onTwitterDefinitionClick() {
    this.isFacebookDefinition = false;
    this.socialContentDefinition.hideDialog();
  }

  hideSocialDefinitionDialog() {
    this.socialContentDefinition.hideDialog();
    // this.showGenericAlertMsgBox('You have saved your social content definition!','Social Content Definition',200);
    this.genericModal.defineModal('You have saved your social content definition!','Social Content Definition',200);
    this._hideInfoModal = false;
  }

  /*private showGenericAlertMsgBox(msg:string,title:string,statusCode:number) {
    this._hideInfoModal = false;
    this._genericModalText = msg;
    this._genericModalTitle = title;
    this._statusCode =  statusCode;
  }*/

  private removeSMSDefinition() {

        this._projectService.removeSmsDefinition(this.project.id,this.selectedQuestionnaire.id,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type)).subscribe((msg)=> {

            if(msg === 100) {
                // this.showGenericAlertMsgBox('SMS definition has been deleted successfully !','Terminal Node',200);
                this.genericModal.defineModal('SMS definition has been deleted successfully !','Terminal Node',200);
            } else if(msg === 102) {
                // this.showGenericAlertMsgBox('An error has occurred while removing SMS Definition!','Terminal Node',msg);
                this.genericModal.defineModal('An error has occurred while removing SMS Definition!','Terminal Node',msg);
            } else if(msg === 204) {
                // this.showGenericAlertMsgBox('An error has occurred while removing Email Definition!','Terminal Node',msg);
                this.genericModal.defineModal('SMS definition has been already deleted!','Terminal Node',msg);
            }
            this._hideInfoModal = false;
        });
  }

    private removeEmailDefinition() {

       /* this._projectService.removeEmailDefinition(this.project.id,this.selectedQuestionnaire.id,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type)).subscribe((msg)=> {

            if(msg === 100) {
                // this.showGenericAlertMsgBox('Email definition has been deleted successfully !','Terminal Node',200);
                this.genericModal.defineModal('Email definition has been deleted successfully !','Terminal Node',200);
            } else if(msg === 102) {
               // this.showGenericAlertMsgBox('An error has occurred while removing Email Definition!','Terminal Node',msg);
                this.genericModal.defineModal('An error has occurred while removing Email Definition!','Terminal Node',msg);
            } else if(msg === 204) {
                // this.showGenericAlertMsgBox('An error has occurred while removing Email Definition!','Terminal Node',msg);
                this.genericModal.defineModal('Email definition has been already deleted!','Terminal Node',msg);
            }
            this._hideInfoModal = false;
        });*/
    }

    validate(formGroup:FormGroup):boolean {

      // TODO: It would be nice to have a popup with invalid fields
        return formGroup.valid;
    }

    getDeviceListUsedForThisTerminal(tID:number) {
        this._projectService.listDevicesUsedForATerminal(tID).subscribe(
            (res:Device[])=> {
                for(let i  =0 ;i< res.length;i++) {
                    this.devices.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(res[i], Device));
                }
            }
        );
    }

    setTerminalAsGallery(item: any, srcElement: HTMLInputElement) {
            this.terminal.isGallery = srcElement.checked;
            this.setSrcDataTerminal(0);
    }

    getDataSrcTerminalList():string[] {
      return MapUtil.extractStringArray(this._srcDataTerminalList.keys());
    }

    private extractSelectedValue():string {

      let tmp = this.getDataSrcTerminalList()[0];
      if(this.terminal.dataSrcTId!==0) {
          this._srcDataTerminalList.forEach((val:Terminal,key:string)=> {
              if(val!=null && val.id ===this.terminal.dataSrcTId ) {
                  tmp = val.name;
              }
          });
      }
      return tmp;
    }

    prepareListOfSrcTerminal() {
      // const listTerminal:Terminal[]  = [];
        this._srcDataTerminalList.set('Select a data source terminal',null);
      for (const quest of this.project.questionnaires) {
          for(const term of quest.terminals) {
              this._srcDataTerminalList.set(term.name,term);
          }
      }
    }

    onMailComposerClick() {
        this.emailComposerComponent.toggleDialog();
    }
}
